import { motion } from 'framer-motion';
import React, { FC } from 'react';
import IcomoonIcon from '../icomoon-icon/icomoon-icon';

const FormSuccessBlockTick: FC = () => {
  return (
    <motion.div
      animate={{ scale: 1 }}
      className="bg-turquoise h-16 flex items-center justify-center rounded-full w-16"
      initial={{ scale: 0 }}
    >
      <motion.div
        animate={{ scale: 1.2 }}
        className="leading-none"
        transition={{
          delay: 0.2,
          duration: 0.2,
          repeat: 1,
          repeatType: 'mirror',
        }}
      >
        <motion.div
          animate={{ opacity: 1 }}
          className="leading-none"
          initial={{ opacity: 0 }}
          transition={{
            delay: 0.15,
            duration: 0.2,
          }}
        >
          <IcomoonIcon color="white" name="check" />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default FormSuccessBlockTick;
